import { createResetStateMutation } from '@/helpers';
import { getInitialStateReportes } from './state';

export const setReport = (state, payload) => {
   state.porcentajeUsuariosNivel1Login = payload.porcentajeUsuariosNivel1;
   state.loginsPorPersona = payload.loginsPorPersona;
   state.tablaUsuarios = payload.tablaUsuarios;
   state.cantidadProspectos = payload.cantidadProspectos;
   state.productos = payload.productos;
   state.porcentajeUsuariosNivel1Poliza =
      payload.porcentajeUsuariosNivel1Poliza;
   state.polizasEmitidas = payload.polizasEmitidas;
   state.polizasAlBroker = payload.polizasAlBroker;
   state.sucursalMasActiva = payload.sucursalMasActiva;
   state.usuarioMasActivo = payload.usuarioMasActivo;
   state.ingresoPromedio = payload.ingresoPromedio;
};

export const resetState = createResetStateMutation(getInitialStateReportes);
